.search{display:flex;flex-direction:row-reverse;align-items:center}.search-icon{cursor:pointer}
/*# sourceMappingURL=/ba/public/table-search.component.css.map */
